var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"shopify-store-status flex-grow-1"},[(_vm.status !== 'ok')?_c('pending-view',{attrs:{"connected-store":_vm.connectedStore}}):_c('sync-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }